<script setup lang="ts">
import ChatContainer from '@/components/rc/work-orders/ChatContainer.vue'

const props = defineProps<{ number: string }>()
</script>

<template>
  <ChatContainer :work-order-number="props.number" />
</template>
